export default "__VITE_ASSET__BHRMody7__"